import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "../NewsletterSignupForm.deferred.css";

const SuccessMessage = ({ formatTranslation, showNCCMessaging }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  const bodyKey = showNCCMessaging
    ? "footer_newsletter_success_ncc_body"
    : "footer_newsletter_success_generic_body";

  return (
    <>
      <h3
        ref={titleRef}
        tabIndex={-1}
        data-testid="newsletter-success-title"
        className={styles.feedbackMessage}
      >
        {formatTranslation("footer_newsletter_success_title")}
      </h3>
      <p
        data-testid="newsletter-success-message"
        className={styles.feedbackMessage}
      >
        {formatTranslation(bodyKey)}
      </p>
    </>
  );
};

SuccessMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  showNCCMessaging: PropTypes.bool.isRequired
};

export default SuccessMessage;
